import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { Article, ArticleComment } from '../../../types/items';

export const getArticleCommentListRequest = action(
  'GET_ARTICLE_COMMENT_LIST_REQUEST',
  withPayload<ListParams>(),
);

export const getArticleCommentListSuccess = action(
  'GET_ARTICLE_COMMENT_LIST_SUCCESS',
  withPayload<ItemList<Article>>(),
);

export const getArticleCommentListFail = action(
  'GET_ARTICLE_COMMENT_LIST_FAIL',
  withoutPayload,
);

export const setArticleCommentMessage = action(
  'SET_ARTICLE_COMMENT_MESSAGE',
  withPayload<string>(),
);

export const createArticleCommentRequest = action(
  'CREATE_ARTICLE_COMMENT_REQUEST',
  withPayload<ArticleComment>(),
);

export const createArticleCommentSuccess = action(
  'CREATE_ARTICLE_COMMENT_SUCCESS',
  withoutPayload,
);

export const createArticleCommentFail = action(
  'CREATE_ARTICLE_COMMENT_FAIL',
  withoutPayload,
);

export const clearArticleComment = action(
  'CLEAR_ARTICLE_COMMENT',
  withoutPayload,
);

export const setArticleCommentFocusStatus = action(
  'SET_ARTICLE_COMMENT_FOCUS_STATUS',
  withPayload<boolean>(),
);
